import Accessory from './Accessory';

export default Accessory;
